import { AspectRatio as NbAspectRatio } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const AspectRatio = NbAspectRatio;

export default addWithConfig(AspectRatio);
